/* tslint:disable */
/* eslint-disable */
/**
 * EMLINX API specification
 * This is API specification for EMLINX project.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import { ErrorResponse } from '../models';
// @ts-ignore
import { ListProductsResponse } from '../models';
/**
 * ListproductsApi - axios parameter creator
 * @export
 */
export const ListproductsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * List Products
         * @summary GET Products
         * @param {string} [janCode] Jan Code
         * @param {string} [productName] Product Name
         * @param {number} [page] current page
         * @param {number} [size] The number of items by page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listProducts: async (janCode?: string, productName?: string, page?: number, size?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/products`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (janCode !== undefined) {
                localVarQueryParameter['janCode'] = janCode;
            }

            if (productName !== undefined) {
                localVarQueryParameter['productName'] = productName;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ListproductsApi - functional programming interface
 * @export
 */
export const ListproductsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ListproductsApiAxiosParamCreator(configuration)
    return {
        /**
         * List Products
         * @summary GET Products
         * @param {string} [janCode] Jan Code
         * @param {string} [productName] Product Name
         * @param {number} [page] current page
         * @param {number} [size] The number of items by page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listProducts(janCode?: string, productName?: string, page?: number, size?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ListProductsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listProducts(janCode, productName, page, size, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['ListproductsApi.listProducts']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * ListproductsApi - factory interface
 * @export
 */
export const ListproductsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ListproductsApiFp(configuration)
    return {
        /**
         * List Products
         * @summary GET Products
         * @param {string} [janCode] Jan Code
         * @param {string} [productName] Product Name
         * @param {number} [page] current page
         * @param {number} [size] The number of items by page
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listProducts(janCode?: string, productName?: string, page?: number, size?: number, options?: any): AxiosPromise<ListProductsResponse> {
            return localVarFp.listProducts(janCode, productName, page, size, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ListproductsApi - object-oriented interface
 * @export
 * @class ListproductsApi
 * @extends {BaseAPI}
 */
export class ListproductsApi extends BaseAPI {
    /**
     * List Products
     * @summary GET Products
     * @param {string} [janCode] Jan Code
     * @param {string} [productName] Product Name
     * @param {number} [page] current page
     * @param {number} [size] The number of items by page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ListproductsApi
     */
    public listProducts(janCode?: string, productName?: string, page?: number, size?: number, options?: RawAxiosRequestConfig) {
        return ListproductsApiFp(this.configuration).listProducts(janCode, productName, page, size, options).then((request) => request(this.axios, this.basePath));
    }
}

